import x from "react";
import e from "prop-types";
import y from "lodash.noop";
import t from "./index248.mjs";
import L from "classnames";
import { TEXTAREA_SPELLCHECK as c, TEXTAREA_STATES as R, TEXTAREA_WRAP as p, TEXTAREA_BASE_CLASS as o } from "./index167.mjs";
const w = ({ classes: l, state: r, disabled: a, required: s }) => L(
  t[o],
  t[`${o}--${r}`],
  a && t[`${o}--disabled`],
  s && t[`${o}--required`],
  l
), i = (l) => {
  const {
    autocomplete: r,
    disabled: a,
    id: s,
    maxlength: n,
    minlength: u,
    name: d,
    onChange: g,
    placeholder: h,
    readonly: f,
    required: m,
    rows: T,
    spellcheck: E,
    title: b,
    value: A,
    wrap: C,
    classes: O,
    state: S
  } = l, _ = ({ target: { value: v } }) => {
    g(v);
  };
  return /* @__PURE__ */ x.createElement(
    "textarea",
    {
      autoComplete: r ? "on" : "off",
      className: w({ classes: O, state: S, disabled: a, required: m }),
      disabled: a,
      id: s,
      maxLength: n,
      minLength: u,
      name: d,
      onChange: _,
      placeholder: h,
      readOnly: f,
      required: m,
      rows: T,
      spellCheck: E,
      title: b,
      wrap: C,
      value: A
    }
  );
};
i.propTypes = {
  autocomplete: e.bool,
  disabled: e.bool,
  id: e.string,
  maxlength: e.number,
  minlength: e.number,
  name: e.string,
  placeholder: e.string,
  readonly: e.bool,
  required: e.bool,
  rows: e.number,
  spellcheck: e.oneOf(Object.values(c)),
  state: e.oneOf(Object.values(R)),
  title: e.string,
  wrap: e.oneOf(Object.values(p)),
  onChange: e.func,
  value: e.string,
  classes: e.string
};
i.defaultProps = {
  spellcheck: c.DEFAULT,
  wrap: p.SOFT,
  onChange: y
};
export {
  o as TEXTAREA_BASE_CLASS,
  c as TEXTAREA_SPELLCHECK,
  R as TEXTAREA_STATES,
  p as TEXTAREA_WRAP,
  i as Textarea,
  i as default
};
